import './ProductCardCarousel.scss'

import { LeftOutlined, RightOutlined, ZoomInOutlined } from '@ant-design/icons'
import { Image, Modal } from 'antd'
import React, { useState } from 'react'

interface Props {
    resimler: string[]
    alt?: string
    height?: number
}

const ProductCardCarousel: React.FC<Props> = ({ resimler, alt = '', height = 220 }) => {
    const [current, setCurrent] = useState(0)
    const [hovered, setHovered] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [previewOpen, setPreviewOpen] = useState(false)

    const images = resimler.filter(Boolean)

    if (images.length === 0) {
        return <div style={{ height }} className="pcc-empty" />
    }

    const prev = (e: React.MouseEvent) => {
        e.stopPropagation()
        setCurrent((c) => (c - 1 + images.length) % images.length)
    }
    const next = (e: React.MouseEvent) => {
        e.stopPropagation()
        setCurrent((c) => (c + 1) % images.length)
    }

    return (
        <>
            <div
                className="pcc-wrapper"
                style={{ height }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={() => setModalOpen(true)}
            >
                <div className="pcc-track" style={{ transform: `translateX(-${current * 100}%)` }}>
                    {images.map((src, i) => (
                        <img key={i} src={src} alt={alt} className="pcc-img" />
                    ))}
                </div>

                <div className={`pcc-zoom${hovered ? ' visible' : ''}`}>
                    <ZoomInOutlined />
                </div>

                {images.length > 1 && (
                    <>
                        <button className={`pcc-btn pcc-btn--left${hovered ? ' visible' : ''}`} onClick={prev}>
                            <LeftOutlined />
                        </button>
                        <button className={`pcc-btn pcc-btn--right${hovered ? ' visible' : ''}`} onClick={next}>
                            <RightOutlined />
                        </button>
                        <div className="pcc-dots">
                            {images.map((_, i) => (
                                <span
                                    key={i}
                                    className={`pcc-dot${i === current ? ' active' : ''}`}
                                    onClick={(e) => { e.stopPropagation(); setCurrent(i) }}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>

            <Modal
                open={modalOpen}
                onCancel={(e) => { e.stopPropagation(); setModalOpen(false) }}
                footer={null}
                centered
                width={600}
                className="pcc-modal"
                destroyOnClose
            >
                <div className="pcc-modal-inner">
                    <div className="pcc-modal-track" style={{ transform: `translateX(-${current * 100}%)` }}>
                        {images.map((src, i) => (
                            <img key={i} src={src} alt={alt} className="pcc-modal-img" />
                        ))}
                    </div>

                    <button
                        className="pcc-btn pcc-zoom-btn visible"
                        onClick={(e) => { e.stopPropagation(); setPreviewOpen(true) }}
                        title="Büyüt"
                    >
                        <ZoomInOutlined />
                    </button>

                    {images.length > 1 && (
                        <>
                            <button className="pcc-btn pcc-btn--left visible pcc-btn--modal" onClick={prev}>
                                <LeftOutlined />
                            </button>
                            <button className="pcc-btn pcc-btn--right visible pcc-btn--modal" onClick={next}>
                                <RightOutlined />
                            </button>
                            <div className="pcc-dots pcc-dots--modal">
                                {images.map((_, i) => (
                                    <span
                                        key={i}
                                        className={`pcc-dot${i === current ? ' active' : ''}`}
                                        onClick={(e) => { e.stopPropagation(); setCurrent(i) }}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            <div style={{ display: 'none' }}>
                <Image.PreviewGroup
                    preview={{
                        visible: previewOpen,
                        current,
                        onVisibleChange: (vis) => setPreviewOpen(vis),
                    }}
                >
                    {images.map((src, i) => (
                        <Image key={i} src={src} alt={alt} />
                    ))}
                </Image.PreviewGroup>
            </div>
        </>
    )
}

export default ProductCardCarousel
